/** The deterministic `user_quest` row id for a quest: one row per quest, on every device. */
export function userQuestId(questId: string): string {
  return `quest:${questId}`;
}
